import { render, staticRenderFns } from "./FormItemSelect.vue?vue&type=template&id=46ec1345&scoped=true"
import script from "./FormItemSelect.vue?vue&type=script&lang=js"
export * from "./FormItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec1345",
  null
  
)

export default component.exports